module.exports = {"attributes":{},"content":"<svg><circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#ec6839\"/></svg>"}